export default "__VITE_ASSET__6f711a4b__"